import { render, staticRenderFns } from "./VideoQuickTour.vue?vue&type=template&id=7e23e31d"
import script from "./VideoQuickTour.vue?vue&type=script&lang=js"
export * from "./VideoQuickTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports